// extracted by mini-css-extract-plugin
module.exports = {"titleClass":"ProfileSideDrawer_titleClass__3etgy","modalContentClass":"ProfileSideDrawer_modalContentClass__2znPQ","modalboxClass":"ProfileSideDrawer_modalboxClass__qurcf"};